import React from 'react'
import { useEffect, useSelector } from 'hooks'
import { Button, T, Banner, UserList } from 'components'
import StyledHome from './StyledHome'
import { BANNERS } from 'common/constants'

const MobileHeader = () => (
  <div className="header mobileOnly">
    <T label="sections/newMembers" />
    <Button to="/browse?filters=new" fill="transparent" color="highlight" label="viewMore" />
  </div>
)

const Home = () => {
  const gold = useSelector(s => s.myProfile.gold)

  useEffect(() => {
    history.replaceState(null, document.title, location.pathname.replace(/(\/rct)?\/.*/, '$1'))
  }, [])

  return (
    <StyledHome gold={gold}>
      <UserList limit={12} filter="new" Header={MobileHeader} />

      <div className="bottom">
        <div className="left">
          <UserList vertical placeholders={2} limit={9} filter="matches" title="newMatches" />
        </div>

        <div className="right">
          <Banner external instanceId={BANNERS.HOME} fallback="Ad space 300x250" />
        </div>
      </div>
    </StyledHome>
  )
}

export default Home
